<!-- src/app/jobs/browse-jobs-index/browse-jobs-index.component.html -->
<div class="px-5 pt-10 pb-15 w-full md:w-[768px] xl:w-[1280px] mx-auto">

  <!-- Breadcrumbs -->
  <nav class="flex items-center gap-2 text-sm text-gray-500 mb-6">
    <a routerLink="/" class="hover:text-gray-800 transition-colors">Home</a>
    <span>/</span>
    <span class="text-gray-800 font-medium">Browse Jobs</span>
  </nav>

  <!-- Hero -->
  <div class="bg-gradient-to-b from-white to-blue-50 border border-blue-100 rounded-2xl p-8 mb-9 shadow-xs">
    <div class="max-w-3xl">

      <div class="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-blue-50 text-blue-600 text-xs font-bold uppercase tracking-wider mb-4">
        Browse Jobs
      </div>

      <h1 class="text-4xl font-bold leading-tight text-gray-900 mt-0 mb-3">
        Browse Truck Driving Jobs
      </h1>

      <p class="text-gray-500 text-lg leading-relaxed mt-0 mb-5">
        Browse truck driving jobs by category.
      </p>

      <div class="flex gap-2.5 flex-wrap mb-6">
        <a routerLink="/jobs" mat-flat-button color="primary">
          Search All Jobs
        </a>
        <button mat-stroked-button type="button" (click)="scrollToSection('state')">
          Browse by State
        </button>
      </div>

      <!-- Quick Links -->
      <div class="grid gap-3"
     style="grid-template-columns: repeat(auto-fit, minmax(220px, 1fr))">
  @for (link of quickLinks; track link.label) {
    @if (link.anchor) {
      <button
        type="button"
        class="text-left p-4 border border-gray-200 rounded-xl bg-white text-gray-900 hover:border-blue-300 hover:shadow-sm transition-all duration-150 w-full"
        (click)="scrollToSection(link.anchor)"
      >
        <div class="text-sm font-bold mb-1">{{ link.label }}</div>
        <div class="text-xs text-gray-500 leading-relaxed">{{ link.desc }}</div>
      </button>
    } @else {
      <a
        [routerLink]="link.url"
        class="block p-4 border border-gray-200 rounded-xl bg-white no-underline text-gray-900 hover:border-blue-300 hover:shadow-sm transition-all duration-150"
      >
        <div class="text-sm font-bold mb-1">{{ link.label }}</div>
        <div class="text-xs text-gray-500 leading-relaxed">{{ link.desc }}</div>
      </a>
    }
  }
</div>


    </div>
  </div>

  <!-- Supporting copy -->
  <p class="max-w-4xl text-gray-500 text-base leading-relaxed mb-7">
    Find active trucking jobs by the filters that matter most. Browse by state for local opportunities,
    by driver type to compare employment styles, or by CDL class, freight type, endorsement, and
    experience level to narrow your search quickly.
  </p>

  <!-- Loading -->
  @if (loading()) {
    <div class="flex justify-center items-center py-20">
      <mat-spinner diameter="48" />
    </div>
  }

  <!-- Taxonomy Sections -->
  @else {
    @for (section of sections(); track section.slug) {
      <div [id]="section.slug" class="mb-12">

        <!-- Section Header -->
        <div class="flex items-baseline justify-between gap-3 mb-4 pb-3 border-b-2 border-gray-100">
          <div>
            <h2 class="text-2xl font-semibold text-gray-900 m-0">{{ section.label }}</h2>
            <p class="text-sm text-gray-400 mt-1.5 mb-0">
              Explore active truck driving jobs in this category.
            </p>
          </div>
          <span class="text-sm text-gray-400 whitespace-nowrap">
            {{ section.items.length }} options
          </span>
        </div>

        <!-- Items Grid -->
        <div class="grid gap-2.5"
             style="grid-template-columns: repeat(auto-fill, minmax(220px, 1fr))">
          @for (item of section.items; track item.slug) {
            <a
              [routerLink]="item.url"
              class="flex items-center justify-between gap-2.5 px-3.5 py-3 bg-white border border-gray-200 rounded-xl no-underline text-gray-900 text-sm hover:border-blue-400 hover:shadow-md hover:-translate-y-px transition-all duration-150"
            >
              <span class="font-semibold leading-snug">{{ item.label }}</span>
              <span class="shrink-0 bg-blue-50 text-blue-600 text-xs font-bold px-2 py-0.5 rounded-full whitespace-nowrap">
                {{ item.count | number }}
              </span>
            </a>
          }
        </div>

      </div>
    }
  }

</div>
